module.exports = __webpack_public_path__ + "static/media/severity_medium.805fce45.svg";